'use client';

import {type FC, useMemo} from 'react';
import clsx from 'clsx';
import {useSearchParams} from 'next/navigation';

import {searchParamsToFilters} from '@/components/article-search-filters/search-params-filter';
import {FadeInScroll} from '@/components/framer/fade-in-scroll';
import type {Articles365ListAllQueryResult} from '@/schemas/types';

import {Item} from './components/item';

interface Props {
	articles?: Articles365ListAllQueryResult;
}

export const ArticleList365Client: FC<Props> = ({articles}) => {
	const searchParams = useSearchParams();

	const filters = searchParamsToFilters(searchParams);

	const filteredArticles = useMemo(() => {
		const categories = filters.tema;

		return articles?.filter((article) => {
			if (categories?.length === 0) {
				return true;
			}

			return articleMatchesCategories(article, categories ?? []);
		});
	}, [articles, filters.tema]);

	return (
		<FadeInScroll margin={40}>
			<div
				className={clsx(
					'grid',
					'grid-cols-1',
					'gap-6',
					'sm:grid-cols-2',
					'lg:grid-cols-3',
					'mt-32',
				)}
			>
				{filteredArticles?.map((article) => (
					<Item key={article._id} article={article} />
				))}
			</div>
		</FadeInScroll>
	);
};

const articleMatchesCategories = (
	article: Articles365ListAllQueryResult[number],
	categories: string[],
) => {
	if (!article.category?.slug) {
		return false;
	}
	if (categories.length === 0) {
		return true;
	}

	return categories.includes(article.category.slug);
};
